import { FORM_ERROR } from '@constants/messages';

export function renderFormErrorMessages() {
    return FORM_ERROR('Licensor');
}

export function renderTitle() {
    return null;
}
